import { setProperty } from './tools/fn';
export const filename = setProperty('resultFilename');
export const timeout = setProperty('waitTimeout');
export const delay = setProperty('waitDelay');
export const webhook = setProperty('webhookURL', 'webhookURLTimeout');
export const googleChromeRpccBufferSize = setProperty('googleChromeRpccBufferSize');
export const range = setProperty('pageRanges');
export const scale = setProperty('scale');
